const CognitoExceptions = {
    NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
    INVALID_CREDENTIALS: 'Incorrect username or password.',
    PASSWORD_ATTEMPTS_EXCEEDED: 'Password attempts exceeded'
};

export default CognitoExceptions;
